import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-action-code-handler-page',
  templateUrl: './action-code-handler-page.component.html',
  styleUrls: ['./action-code-handler-page.component.scss'],
})
export class ActionCodeHandlerPageComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const oobCode = urlParams.get('oobCode');
    const apiKey = urlParams.get('apiKey');
    const continueUrl = urlParams.get('continueUrl');
    const mode = urlParams.get('mode');

    if (oobCode) {
      switch (mode) {
        case 'signIn':
          this.router.navigate(['/email-link-login'], {
            queryParams: { oobCode, apiKey, continueUrl, mode },
          });
          break;
        case 'resetPassword':
          this.router.navigate(['/change-password'], {
            queryParams: { oobCode, apiKey, continueUrl, mode },
          });
          break;
        case 'verifyAndChangeEmail':
          this.authService
            .applyActionCode(oobCode)
            .then(() => {
              this.router.navigate(['/email-verification-result'], {
                queryParams: { success: true },
              });
            })
            .catch(error => {
              this.router.navigate(['/email-verification-result'], {
                queryParams: { success: false, error: error.message },
              });
            });
          break;
        default:
          break;
      }
    }
  }
}
